import React from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import styled from 'styled-components';
import ButtonCopy from '../../../../Forms/ButtonCopy';

const VANumberDiv = styled.div`
  background-color: #dddddd;
  padding: 20px;
  margin-top: 1rem;
  min-width: 200px;
  > p{
    font-weight: 700;
    font-size: 1rem;
    text-align: center;
    letter-spacing: 1.5px;
    margin: 0;
    text-align: center;
  }
`

const VANumberPlaceholder = ({ vaNumber }) => (
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
    <div>
      <VANumberDiv>
        <p>{ vaNumber }</p>
      </VANumberDiv>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <ButtonCopy
          hide={vaNumber && vaNumber.indexOf('X') > -1}
          value={vaNumber}
        >
          <i className="fa fa-clone" aria-hidden="true"></i>Copy
        </ButtonCopy>
      </div>
    </div>
  </div>
)

VANumberPlaceholder.propTypes = {
  vaNumber: propTypes.oneOfType([propTypes.string, propTypes.number])
}
VANumberPlaceholder.defaultProps = {
  vaNumber: null
}

export default VANumberPlaceholder;